import { render, staticRenderFns } from "./DocumentExtraFieldsPortcallGrid.vue?vue&type=template&id=8881d676"
import script from "./DocumentExtraFieldsPortcallGrid.vue?vue&type=script&lang=js"
export * from "./DocumentExtraFieldsPortcallGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports